import SBDDistribution from './SBDDistribution';

export default SBDDistribution;
